__turbopack_context__.v({
  "articleContainer": "HomepageValueProps-module-scss-module__Zimeoq__articleContainer",
  "articlesContainer": "HomepageValueProps-module-scss-module__Zimeoq__articlesContainer",
  "copy": "HomepageValueProps-module-scss-module__Zimeoq__copy",
  "cta": "HomepageValueProps-module-scss-module__Zimeoq__cta",
  "fiveItems": "HomepageValueProps-module-scss-module__Zimeoq__fiveItems",
  "fourItems": "HomepageValueProps-module-scss-module__Zimeoq__fourItems",
  "hasLink": "HomepageValueProps-module-scss-module__Zimeoq__hasLink",
  "heading": "HomepageValueProps-module-scss-module__Zimeoq__heading",
  "icon": "HomepageValueProps-module-scss-module__Zimeoq__icon",
  "imageContainer": "HomepageValueProps-module-scss-module__Zimeoq__imageContainer",
  "mainHeading": "HomepageValueProps-module-scss-module__Zimeoq__mainHeading",
  "reduceMarginTop": "HomepageValueProps-module-scss-module__Zimeoq__reduceMarginTop",
  "sectionContainer": "HomepageValueProps-module-scss-module__Zimeoq__sectionContainer",
  "threeItems": "HomepageValueProps-module-scss-module__Zimeoq__threeItems",
  "twoItems": "HomepageValueProps-module-scss-module__Zimeoq__twoItems",
  "valuePropLink": "HomepageValueProps-module-scss-module__Zimeoq__valuePropLink",
});
